import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getResponses = async (activityId) => {
    const { data } = await vlqrApi.get(`/focusGroupRankingActivities/${activityId}/responses`)
        .catch((error) => {
            handleError(error);
        });
    return data?.filter(x => !x.deletedOn);
};

const getResponsesForCrossSessionActivity = async (crossSessionActivityId) => {
    const { data } = await vlqrApi.get(`/focusGroupRankingActivities/crossSession/${crossSessionActivityId}/responses`)
        .catch((error) => {
            handleError(error);
        });

    return data?.filter(x => !x.deletedOn);
};

const useRankingAnswersForActivity = ({ activityId, crossSessionId }) => {
    const queryKey = [crossSessionId
        ? 'rankingResponsesForCrossSessionActivity'
        : 'rankingResponsesForActivity'];
    const queryKeyValue = crossSessionId ?? activityId;

    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: [queryKey, queryKeyValue],
        queryFn: () => crossSessionId
            ? getResponsesForCrossSessionActivity(crossSessionId)
            : getResponses(activityId)
    });

    return { data, refetch, isLoading, isError };
};

export default useRankingAnswersForActivity;
